export default __webpack_public_path__ + "static/media/liberty.4756024c.jpg";